import {
  useRadioGroup,
  HStack,
  VStack,
  FormControl,
  FormLabel,
  Heading,
  Input,
  InputGroup,
  Button,
  Stack,
  Text,
  RadioGroup,
  Radio,
} from '@chakra-ui/react'
import { useContext, useState } from 'react'
import { isValidSHA256 } from '../../utils/minorUtils'
import RadioCard from '../RadioCard'
import { sha256, toUtf8Bytes } from 'ethers/lib/utils.js'
import { RPSContext } from '../../context/RPSContext'
import { usePrepareContractWrite, useContractWrite, useWaitForTransaction } from 'wagmi'
import RockPaperScissorsABI from '../../assets/constants/abi/RockPaperScissors.json'
import NetworkMapping from '../../assets/constants/network-mapping.json'

const EnterSecret = () => {
  const options = ['Rock', 'Paper', 'Scissors']
  const [entryType, setEntryType] = useState('CreateHash')
  const [secretHash, setSecretHash] = useState('')
  const [secretText, setSecretText] = useState('')
  const [directHash, setDirectHash] = useState('')
  const [secretHashDirect, setSecretHashDirect] = useState('')
  const updateSecretHash = (val: any) => {
    createSecretHash(secretText, val)
  }
  const { getRootProps, getRadioProps, value } = useRadioGroup({
    name: 'RockPaperScissors',
    defaultValue: 'Rock',
    onChange: updateSecretHash,
  })
  const group = getRootProps()
  const { gameDetails, nextForm } = useContext(RPSContext)

  function createSecretHash(secret: string, newValue?: any) {
    if (entryType === 'CreateHash' && secret) {
      let finalString = `${newValue || value}-${secret}`
      setSecretText(secret)
      setSecretHash(sha256(toUtf8Bytes(finalString)))
    } else if (entryType === 'EnterHash') {
      setDirectHash(secret)
      setSecretHashDirect('')
      if (isValidSHA256(secret)) {
        let finalString = `0x${secret}`
        setSecretHashDirect(finalString)
      }
    }
  }

  const { config, isError: isPrepareError } = usePrepareContractWrite({
    address: NetworkMapping['80001']['RockPaperScissors'] as `0x${string}`,
    abi: RockPaperScissorsABI,
    functionName: gameDetails.state === -1 ? 'initiateGame' : 'respond',
    args:
      gameDetails.state === -1
        ? [gameDetails.responder, entryType === 'CreateHash' ? secretHash : secretHashDirect]
        : [gameDetails.initiator, entryType === 'CreateHash' ? secretHash : secretHashDirect],
    enabled:
      gameDetails.state === -1
        ? gameDetails.responder && (secretHash || secretHashDirect)
        : gameDetails.initiator && (secretHash || secretHashDirect),
  })

  const { data, isError, write } = useContractWrite(config)

  const { isLoading } = useWaitForTransaction({
    hash: data?.hash,
    onSuccess() {
      nextForm(5)
    },
  })

  function updateChange(val: any) {
    setEntryType(val)
    setSecretHash('')
    setSecretHashDirect('')
    setSecretText('')
    setDirectHash('')
  }

  return (
    <VStack minW={{ base: 'md', md: 'lg', lg: 'lg' }}>
      <Heading fontSize={'2xl'} textAlign={'center'}>{`${
        gameDetails.state === -1 ? 'Initiator' : 'Responder'
      } Secret Hash`}</Heading>

      <RadioGroup onChange={(e) => updateChange(e)} value={entryType} alignSelf={'start'}>
        <Stack my={'1rem'}>
          <Radio size="lg" value="CreateHash" colorScheme={'teal'}>
            Create Secret Hash
          </Radio>
          <Radio size="lg" value="EnterHash" colorScheme={'teal'}>
            Enter Secret Hash
          </Radio>
        </Stack>
      </RadioGroup>

      {entryType === 'EnterHash' && (
        <FormControl id="secretHash">
          <FormLabel>Secret Hash</FormLabel>
          <InputGroup>
            <Input
              placeholder="Paste a Valid Secret Hash"
              _placeholder={{ color: 'gray.500' }}
              type="text"
              maxLength={64}
              value={directHash}
              onChange={(e) => createSecretHash(e.target.value)}
              maxW={'md'}
            />
          </InputGroup>
        </FormControl>
      )}
      {entryType === 'CreateHash' && (
        <>
          <FormControl id="createHash">
            <FormLabel>Choose</FormLabel>
            <HStack {...group} mb={'1rem'}>
              {options.map((value) => {
                const radio = getRadioProps({ value })
                return (
                  <RadioCard key={value} {...radio}>
                    {value}
                  </RadioCard>
                )
              })}
            </HStack>
          </FormControl>
          <FormControl id="createHash">
            <FormLabel>
              Secret <span style={{ color: 'brown' }}>[Case Sensitive]</span>
            </FormLabel>
            <Input
              placeholder="Secret Word"
              _placeholder={{ color: 'gray.500' }}
              type="password"
              value={secretText}
              onChange={(e) => createSecretHash(e.target.value)}
              maxW={'md'}
            />
          </FormControl>
        </>
      )}
      {(secretHash || secretHashDirect) && (
        <Stack py={'0.8rem'}>
          <Heading fontSize={'xl'}>Secret Hash</Heading>
          <Text noOfLines={1} fontSize={'sm'}>
            {entryType === 'CreateHash' ? secretHash : secretHashDirect}
          </Text>
        </Stack>
      )}
      <Stack pt={'1rem'}>
        <Button
          colorScheme="teal"
          variant="outline"
          isDisabled={isError || isPrepareError || isLoading}
          onClick={(e) => {
            e.preventDefault()
            write?.()
          }}
        >
          {`${gameDetails.state === -1 ? 'Initiate Game' : 'Submit Response'}`}
        </Button>
      </Stack>
    </VStack>
  )
}
export default EnterSecret
